import React from "react";
import classes from "./BottomBanner.module.css";

const BottomBanner = () => {
  return (
    <div className={classes.banner}>
      <div>🎉 Enjoy 35% Off Your All Inclusive Detox Retreat</div>
      <a
        href="https://www.amitywellness.com"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.bannerLink}
      >
        ⬅ Return to Home Page
      </a>
    </div>
  );
};

export default BottomBanner;
